<template>
  <div class="firstDivClass">
    <div>总回复数: {{ sum }}</div>
    <div v-if="replysDateArray.length === 0"></div>
    <div v-else style="height: 50vh">
      <el-scrollbar style="height: 100%;">
        <div
          v-for="reply in replysDateArray"
          v-bind:key="reply.replyId"
          class="feedbackList"
        >
          <div class="nameAndContentClass">
            <span class="userNameClass">
              {{ reply.userName }}
            </span>
            <span class="adminReplyContentClass">
              {{ reply.content }}
            </span>
          </div>
          <div class="timeClass">
            <span>
              {{ new Date(reply.addDate).toLocaleString() }}
            </span>
          </div>
          <hr />
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    replyId: Number
  },
  data () {
    return {
      sum: 0,
      nowPage: 1,
      pageSize: 1000,
      replysDateArray: []
    }
  },
  mounted: async function () {
    const that = this
    const api = '/md/front/bbs/feedback/all/subs'
    let params = {
      userReplyId: this.replyId,
      nowPage: this.nowPage,
      pageSize: this.pageSize
    }
    params = this.$qs.stringify(params)
    const res = await this.axios.post(api, params)
    if (res.status === 200) {
      that.sum = res.data.sum
      that.replysDateArray = res.data.list
    }
  }
}
</script>

<style scoped>
.userNameClass {
  display: inline-block;
  width: 10%;
}
.adminReplyContentClass {
  display: inline-block;
  width: 61%;
  letter-spacing: 2px;
}
.timeClass {
  text-align: right;
  margin-right: 3.5%;
}
.nameAndContentClass {
  display: flex;
  flex-direction: row;
  justify-content: baseline;
  align-items: flex-start;
}
</style>
